// Central content for MonthlyPops.com — edit these to update the site.

export const LINKS = {
  shopify: "https://monthlypops.com",
  whatnot: "https://www.whatnot.com/user/monthlypops",
  tiktok: "https://www.tiktok.com/@monthlypops",
  ebay: "https://www.ebay.com/str/monthlypops",
  autographedFunko: "https://monthlypops.com/collections/autographed-funko",
  signings: "https://monthlypops.com/collections/autograph-signings",
  onePiece: "https://monthlypops.com/collections/one-piece-card-game",
  instagram: "https://www.instagram.com/monthlypops",
};

export const STATS = [
  { value: "6", suffix: "YRS", label: "Longest-running auctioneer on Whatnot" },
  { value: "50", suffix: "K+", label: "Followers across the platform" },
  { value: "100", suffix: "K+", label: "Items sold to collectors worldwide" },
  { value: "50", suffix: "K+", label: "Positive reviews from happy collectors" },
];

export const CHANNELS = [
  {
    key: "whatnot",
    name: "Whatnot",
    tagline: "The main stage.",
    copy: "Six years live and counting — the longest-running auctioneer on the entire platform. Nightly shows, grails, breaks and the best community in the hobby.",
    meta: "50,000+ followers · 100,000+ items sold",
    cta: "Follow on Whatnot",
    href: LINKS.whatnot,
    span: "lg:col-span-7",
    accent: true,
    status: "LIVE MOST NIGHTS",
  },
  {
    key: "tiktok",
    name: "TikTok Live",
    tagline: "Just getting started.",
    copy: "Our first-ever TikTok live show drops this week. Same energy, brand-new stage.",
    meta: "New shows launching now",
    cta: "Follow on TikTok",
    href: LINKS.tiktok,
    span: "lg:col-span-5",
    accent: false,
    status: "PREMIERE THIS WEEK",
  },
  {
    key: "ebay",
    name: "eBay Store",
    tagline: "Always open.",
    copy: "Over 3,000 items listed and ready to ship right now. Buy it now, no waiting for the gavel.",
    meta: "3,000+ live listings",
    cta: "Browse the eBay store",
    href: LINKS.ebay,
    span: "lg:col-span-12",
    accent: false,
    status: "3,000+ ITEMS LISTED",
  },
];

export const PRODUCTS = [
  {
    id: "p1",
    title: "Ming-Na Wen — Fennec Shand",
    subtitle: "Autographed Funko Pop · Witnessed COA",
    price: "$125",
    image:
      "https://images.unsplash.com/photo-1659651699027-f7b705f981bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "In Stock",
    href: LINKS.autographedFunko,
  },
  {
    id: "p2",
    title: "Chuck Huber — Super Android 17",
    subtitle: "DBZ/GT · Autographed · Witnessed MAS COA",
    price: "$150",
    image:
      "https://images.unsplash.com/photo-1623295783032-6af0e569659e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "In Stock",
    href: LINKS.autographedFunko,
  },
  {
    id: "p3",
    title: "Vincent LaRusso — Adam Banks",
    subtitle: "Mighty Ducks · Autographed Funko Pop",
    price: "$75",
    image:
      "https://images.unsplash.com/photo-1659651653463-5b049384df85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "In Stock",
    href: LINKS.autographedFunko,
  },
  {
    id: "p4",
    title: "Dallas Reid — Asta with Nero",
    subtitle: "Black Clover · Autographed · Witnessed COA",
    price: "$150",
    image:
      "https://images.unsplash.com/photo-1659651723894-78289c1aefe3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Grail",
    href: LINKS.autographedFunko,
  },
  {
    id: "p5",
    title: "Kent Williams — Signing Slot",
    subtitle: "Send-in your item · Private signing",
    price: "$65",
    image:
      "https://images.unsplash.com/photo-1554920772-3a4175a4a1ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tag: "Open",
    href: LINKS.signings,
  },
];

export const COLLECTIONS = [
  {
    name: "Autographed Funko",
    count: "Signed & authenticated",
    image:
      "https://images.unsplash.com/photo-1623295783032-6af0e569659e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    href: LINKS.autographedFunko,
  },
  {
    name: "Private Signings",
    count: "Send-in your items",
    image:
      "https://images.unsplash.com/photo-1673196649671-eb09066ad6c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    href: LINKS.signings,
  },
  {
    name: "One Piece TCG",
    count: "Sealed booster boxes",
    image:
      "https://images.unsplash.com/photo-1647893976852-71b2f6ba10e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    href: LINKS.onePiece,
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "We built this live.",
    body: "Monthly Pops started on Whatnot and never left. Six years, 100,000+ items, one gavel at a time — the longest-running auctioneer on the platform.",
  },
  {
    no: "02",
    title: "Authenticity is the product.",
    body: "Every high-end piece is Witnessed OR Authenticated. Private signings, in-person witnessing, real COAs. No mystery, no maybes.",
  },
  {
    no: "03",
    title: "Your collection, our stage.",
    body: "Sitting on grails? Send them in. We consign your pieces to 50,000+ buyers and turn dust-collectors into cash — you set the reserve, we do the rest.",
  },
];

export const PARTNERS = ["FUNKO", "WHATNOT", "ENCORE", "HOBBYDB", "TIKTOK", "EBAY"];

export const CATEGORIES = [
  "Autographed Funko Pop",
  "Sports Memorabilia",
  "Trading Cards / TCG",
  "Comics",
  "Full Collection",
  "Other Collectible",
];
